import { graphql } from "gql";

const EDIT_MESSAGE_REACTION_MUTATION = graphql(`
  mutation EditMessageReaction(
    $id: ID!
    $type: ReactionType!
    $isSet: Boolean!
    $fileId: ID
  ) {
    editMessage(
      id: $id
      input: {
        reactionInput: { reactionType: $type, isSet: $isSet, fileId: $fileId }
      }
    ) {
      id
      reactionList {
        id
        userId
        type
        fileId
      }
    }
  }
`);

export default EDIT_MESSAGE_REACTION_MUTATION;
